import {INVENTORY_FETCH_ASSET_START, INVENTORY_FETCH_ASSET_SUCCESS, INVENTORY_FETCH_ASSET_FAILURE} from '../../actions/actionTypes';

const initialState = {
    loading: false,
    loaded: false,
    error: null,
    data: null,
};

export function assetsReducer(state = initialState, action){
    switch(action.type){
        case INVENTORY_FETCH_ASSET_START:
            return { loading: true, loaded: false, error: null, data: state.data };
        case INVENTORY_FETCH_ASSET_SUCCESS:
            return { loading: false, loaded: true, error: null, data: action.payload };
        case INVENTORY_FETCH_ASSET_FAILURE:
            return {loading: false, loaded: true, error: action.error, data: state.data };
        default:
            return state;
    }
}